;(function() {
  'use strict'

  angular.module('core.tips', [])
})()
